/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import Select from "react-select";
// import AddStores from "./addstore.jsx";
import {
  APIgetRoles,
  updateUserProfile,
  addUser,
  updateUserPassword,
  setUserLocations,
  //unassignUserStore,
} from "../../../api/settings.ts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import AddStoresModal from "./AddStoresModal.jsx";
import { APIGetUserLocations } from "../../../api/stores.ts";
//import axios from "axios";

// eslint-disable-next-line react/display-name
const EditUsers = forwardRef(({ edit, refetchUser }, ref) => {
  console.log("forwardRef");
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const MySwal = withReactContent(Swal);
  const [formDataList, setFormData] = useState({});
  const [initialEditData, setInitialEditData] = useState({});
  const [allRoles, setAllRoles] = useState([]);
  const [dataRole, setDataRole] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  //  const [showAddStoresModal, setShowAddStoresModal] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [storesData, setStoresData] = useState([]);
  const [checkboxData, setCheckboxData] = useState({});
  //
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const handleSelectStores = (selectedStores) => {
    setStoresData(selectedStores);
  };

  useImperativeHandle(ref, () => ({
    resetData: () => {
      setFormData({ ...initialEditData });
      setFormData({});
      setPassword("");
      setConfirmPassword("");
      setError("");
    },
  }));

  //
  const getRolesApi = async () => {
    const res = await APIgetRoles({});
    if (res?.response?.roles) {
      const roleData = res.response.roles;
      const role = roleData.map((item) => {
        return { label: item.title, value: item._id };
      });
      setDataRole(role);
      setAllRoles(roleData);
    }
  };

  const handleCheckboxChange = (storeCode, field) => {
    setCheckboxData((prevState) => {
      const fieldData = prevState[field] || [];
      const newFieldData = fieldData?.includes(storeCode)
        ? fieldData.filter((item) => item !== storeCode)
        : [...fieldData, storeCode];
      return { ...prevState, [field]: newFieldData };
    });
  };

  const getUserLocations = async () => {
    try {
      const res = await APIGetUserLocations(edit?._id);
      if (res?.response) {
        const storeOptions = res?.response?.dataAccessStores.map((store) => ({
          label: store.title,
          value: store._id,
          storeCode: store.storeNumber,
        }));
        const myStore = res?.response?.myStores.map((store) => ({
          label: store.title,
          value: store._id,
          storeCode: store.storeNumber,
        }));
        const oversees = storeOptions?.map((item) => item.storeCode);
        const workAt = myStore?.map((item) => item.storeCode);
        const o = {};
        o["oversees"] = oversees;
        o["workAt"] = workAt;
        setCheckboxData(o);
        setStoresData(myStore);
      }
      console.log("res", res);
    } catch (error) {
      console.log(error);
    }
  };
  const setUserLocation = async (user) => {
    
   //  eslint-disable-next-line no-debugger
   debugger;
    let UsrDetails = {
      userId: user,
      locations: [
        {
          type: "mystores",
          storeCodes: checkboxData["workAt"] || [],
        },
        {
          type: "dataaccess",
          storeCodes: checkboxData["workAt"] || [],
          // storeCodes: storesData?.map((item) => item.storeCode) || [],
          // type: "dataaccess",
          // storeCodes: checkboxData["oversees"] || [],
        },
        {
          type: "peergroups",
          peerGroupIds: [],
        },
      ],
    };

    try {
      await setUserLocations(UsrDetails);
    } catch (error) {
      console.log("e:", error);
    }
  };
  useEffect(() => {
    getRolesApi();
  }, []);

  useEffect(() => {
    if (!edit._id) return;
    getUserLocations();
  }, [edit]);

  useEffect(() => {
    if (Object.keys(edit).length) {
      const {
        firstName: firstname,
        lastName: lastname,
        email,
        role,
        username,
        profile,
      } = edit;
      const find = dataRole.find((item) => item.label === role);

      const initialData = {
        firstname,
        lastname,
        email,
        selectedRole: find.value,
        username,
        skillSets: profile.skillSets,
        jobTitle: profile.jobTitle,
        jobResponsibilities: profile.jobResponsibilities,
        linkedinProfile: profile.linkedinProfile,
        jobExperience: profile.jobExperience,
        shiftStartTime: profile.shiftStartTime,
        shiftEndTime: profile.shiftEndTime,
      };

      setFormData({ ...initialData });
      setInitialEditData({ ...initialData });
    } else {
      setFormData({});
    }
  }, [edit]);
  //
  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleInputChange = (e) => {
    var { name, value } = e.target;
    if (name === "shiftEndTime" && value < formDataList.shiftStartTime) {
      // Optionally, reset to start time or show an error message
      alert("End time cannot be less than start time.");
      return; // Prevent updating the state if the end time is less than start time
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    //
    if (name == "selectedRole") {
      const find = allRoles.find((item) => item._id == value);
      console.log("find", find);
    }
  };
  //
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleCancel = () => {
    // Reset form data to initial state when cancel is triggered
    setFormData({ ...initialEditData });
    setPassword("");
    getUserLocations();
    setConfirmPassword("");
    setError("");
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (e.target.value !== password) {
      setError("Passwords do not match");
    } else {
      setError("");
    }
  };

  const updatePassword = async (id) => {
    let userDetails = {
      id: id,
      password: password,
      newConfirmPassword: confirmPassword,
    };
    const upRes = await updateUserPassword(userDetails);
    return upRes;
  };

  const submit = async (event) => {
    event.preventDefault();
       //  eslint-disable-next-line no-debugger
   debugger;
    if (!formDataList.selectedRole) {
      alert("Role Not Selected");
      return;
    }
    console.log("for edit checkboxData[workAt]",checkboxData["workAt"])
    if(!checkboxData["workAt"] || checkboxData["workAt"].length<=0)
    {
      alert("Please assign Stores");
      return;
    }
    //com
    console.log("formDataList", formDataList);
    let userUpdatedProfile = {
      ...(Object.keys(edit).length && { id: edit._id }),
      firstName: formDataList.firstname,
      lastName: formDataList.lastname,
      mobile: edit.mobile,
      username: formDataList.username,
      password: password,
      roleId: formDataList.selectedRole,
      email: formDataList.email,

      skillSets: formDataList.skillSets,
      jobTitle: formDataList.jobTitle,
      jobResponsibilities: formDataList.jobResponsibilities,
      linkedinProfile: formDataList.linkedinProfile,
      jobExperience: formDataList.jobExperience,
      shiftStartTime: formDataList.shiftStartTime,
      shiftEndTime: formDataList.shiftEndTime,

      toAdd: true,
    };

    console.log("userUpdatedProfile", userUpdatedProfile);
       //  eslint-disable-next-line no-debugger
   
    if (Object.keys(edit).length) {
      try {
        setBtnLoading(true);
        const res = await updateUserProfile(userUpdatedProfile);
        console.log("setUserLocation",edit._id)
           //  eslint-disable-next-line no-debugger
        const loc = await setUserLocation(edit._id);
        console.log("loc:", loc);
        const id = edit._id;
        // const loc = await setLocation(id);

        if (res) {
          // Close the modal
          document.getElementById("closeButton").click();
          setBtnLoading(false);
          refetchUser();
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: t?.[l]?.["update_successfully?"] || "Update Successfully!",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        if (password && confirmPassword) {
          const upPass = await updatePassword(id);
          console.log("updated", upPass);
        }
      } catch (error) {
        setBtnLoading(false);
        console.log("err", error.response.data.message);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } else {
      if (password != confirmPassword) {
        alert("Password Not Matched");
        return;
      }
      try {
        setBtnLoading(true);
        const res = await addUser(userUpdatedProfile);
        const id = res.response.users[0]._id;
        // const loc = await setLocation(id);
        const upPass = await updatePassword(id);
        if (upPass) {
          document.getElementById("closeButton").click();
          setBtnLoading(false);
          refetchUser();
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: t?.[l]?.["created_successfully"] || "Create Successfully!",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        setBtnLoading(false);
        console.log("error", error.response.data.message);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };
  const removeMethod = async (id) => {
    //const userId = localStorage.getItem("userId");
    try {
      // const res = await unassignUserStore({
      //   storeId: id.value,
      //   userId: userId,
      // });
      //if (res) {
        const stores = storesData.filter((item) => item.value !== id.value);
        const n = {};
        Object.keys(checkboxData)?.forEach((key) => {
          n[key] = checkboxData[key].filter((item) => item != id.storeCode);
        });
        setCheckboxData(n);
        setStoresData(stores);
    //  }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      {/* Add User */}
      <div className="modal fade" id="add-units">
        {/* Add Stores Modal */}
        {isModalOpen && (
          <AddStoresModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            onSelectStores={handleSelectStores}
            selected={storesData}
          />
        )}
        <div className="modal-dialog modal-dialog-centered modal-lg custom-modal-two " style={{ width: "650px" }}>
          <div className="modal-content" style={{ width: "650px" }}>
            <div className="page-wrapper-new p-0">
              <div className="">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4> {t[l]?.["edit_user"] || "Edit User"} </h4>
                  </div>
                  <button
                    id="closeButton"
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t[l]?.["first_name"] || "First Name"}</label>
                          <input
                            type="text"
                            required
                            className="form-control"
                            value={formDataList?.firstname || ""}
                            name="firstname"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t[l]?.["last_name"] || "Last Name"}</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formDataList?.lastname || ""}
                            name="lastname"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t[l]?.["user_name"] || "User Name"}</label>
                          <input
                            type="text"
                            required
                            className="form-control"
                            value={formDataList?.username || ""}
                            name="username"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t[l]?.["email"] || "Email"}</label>
                          <input
                            disabled={Object.keys(edit).length ? true : false}
                            type="email"
                            required
                            className="form-control"
                            value={formDataList?.email || ""}
                            name="email"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t[l]?.["password"] || "Password"}</label>
                          <div className="pass-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder={
                                t?.[l]?.["enter_your_password"] ||
                                "Enter your password"
                              }
                              value={password || ""}
                              onChange={handlePasswordChange}
                              autoComplete="off"
                              required={
                                Object.keys(edit).length ? "" : "required"
                              }
                            />
                            <span
                              className={`fas toggle-password ${
                                showPassword ? "fa-eye" : "fa-eye-slash"
                              }`}
                              onClick={handleTogglePassword}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>
                            {t[l]?.["confirm_password"] || "Confirm Password"}
                          </label>
                          <div className="pass-group">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder={
                                t?.[l]?.["enter_your_password"] ||
                                "Enter your password"
                              }
                              value={confirmPassword || ""}
                              onChange={handleConfirmPasswordChange}
                              autoComplete="off"
                              required={
                                Object.keys(edit).length ? "" : "required"
                              }
                            />
                            <span
                              className={`fas toggle-password ${
                                showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                              }`}
                              onClick={handleToggleConfirmPassword}
                            />
                            <span>{error}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t[l]?.["job_title"] || "Job Title"}</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formDataList?.jobTitle || ""}
                            name="jobTitle"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>
                            {t[l]?.["job_experience"] || "Job Experience"}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formDataList?.jobExperience || ""}
                            name="jobExperience"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>
                            {t[l]?.["linkedin_profile"] || "LinkedIn Profile"}
                          </label>
                          <input
                            type="url"
                            className="form-control"
                            value={formDataList?.linkedinProfile || ""}
                            name="linkedinProfile"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>
                            {t[l]?.["shift_start_time"] || "Shift Start Time"}
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            value={formDataList?.shiftStartTime || ""}
                            name="shiftStartTime"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="input-blocks">
                          <label>
                            {t[l]?.["shift_end_time"] || "Shift End Time"}
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            value={formDataList?.shiftEndTime || ""}
                            name="shiftEndTime"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>
                            {t[l]?.["job_responsibilities"] ||
                              "Job Responsibilities"}
                          </label>
                          <textarea
                            className="form-control"
                            value={formDataList?.jobResponsibilities || ""}
                            name="jobResponsibilities"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>{t[l]?.["skillsets"] || "Skill Sets"}</label>
                          <textarea
                            className="form-control"
                            value={formDataList?.skillSets || ""}
                            placeholder="Comma separated (React, Nodejs, ...)"
                            name="skillSets"
                            onChange={handleInputChange}
                            // onChange={(e) => {
                            //   const hashedKeywords = e.target.value.split(',').map(skill => skill.trim().toLowerCase());
                            //   setFormData((prevState) => ({
                            //     ...prevState,
                            //     skillSets: hashedKeywords
                            //   }));
                            // }}
                          />
                        </div>
                      </div>
                      <div className="row col-lg-12">
                        <label className="mb-2">{t[l]?.["role"] || "Role"}</label>
                        <Select
                          className="select"
                          options={dataRole}
                          placeholder={t?.[l]?.["select_role"] || "Select Role"}
                          name="selectedRole"
                          required
                          value={
                            dataRole?.find(
                              (option) =>
                                option.value === formDataList?.selectedRole
                            ) || ""
                          }
                          onChange={(v) => {
                            handleInputChange({
                              target: {
                                name: "selectedRole",
                                value: v.value,
                              },
                            });
                          }}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              width: "104%", // Adjust the width as needed
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="row col-lg-12 stores-wrapper">
                      <div className="input-blocks">
                        <label> <label> {t[l]?.["stores"] || "Stores"}</label></label>
                        <button
                          type="button"
                          className="btn btn-store full-width"
                          onClick={handleOpenModal}
                        >
                          {t[l]?.["add_stores"] || "Add Stores"}
                        </button>
                      </div>
                      {/* table area  */}
                      <div className="input-blocks">
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                            <th> {t[l]?.["visible_stores"] || "Visible Stores"}</th>
                                <th className="hidden"> {t[l]?.["oversees"] || "Oversees"} </th>
                                <th>  {t[l]?.["works_at"] || "Works At"} </th>
                                <th> {t[l]?.["actions"] || "Actions"}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {storesData.map((item) => (
                              <tr key={item.storeCode}>
                                <td>{item.label}</td>
                                <td className="hidden">
                                  <input
                                    type="checkbox"
                                    name="oversees"
                                    checked={
                                      checkboxData["oversees"]?.includes(
                                        item.storeCode
                                      ) || false
                                    }
                                    onChange={() =>
                                      handleCheckboxChange(
                                        item.storeCode,
                                        "oversees"
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="workAt"
                                    checked={
                                      checkboxData["workAt"]?.includes(
                                        item.storeCode
                                      ) || false
                                    }
                                    onChange={() =>
                                      handleCheckboxChange(
                                        item.storeCode,
                                        "workAt"
                                      )
                                    }
                                  />
                                </td>
                                <td onClick={() => removeMethod(item)} className="removed">
                                {t[l]?.["remove"] || "Remove"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      </div>
                    </div>

                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t[l]?.["cancel"] || "Cancel"}
                      </button>
                      <button
                        disabled={btnLoading}
                        type="submit"
                        className="btn btn-submit"
                      >
                        {/* {!btnLoading ? "Save" : "Wait..."} */}
                        {t[l]?.[btnLoading ? "wait" : "save"] ||
                          (btnLoading ? "Wait..." : "Save")}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
export default EditUsers;
